import { dataDelete, dataOn, dataRef, dataSet } from "../data/data";
import { getPageId } from "./pageId";
import { getNextRefresh } from "../../../utilities/nextRefresh";
export function manageActivePages() {
    const pageId = getPageId();
    const activeRef = dataRef(`active/${pageId}`);
    const nextRefresh = getNextRefresh();
    let once = false;
    dataSet(activeRef, {
        url: location.href,
        lastRefresh: new Date().valueOf(),
        nextRefresh: nextRefresh ? nextRefresh.valueOf() : null,
        userAgent: navigator.userAgent,
        viewport: {
            width: window.innerWidth,
            height: window.innerHeight,
        },
        screen: {
            width: screen.width,
            height: screen.height,
        },
    });
    window.addEventListener("beforeunload", () => {
        dataDelete(activeRef);
    });
    fetch("https://www.cloudflare.com/cdn-cgi/trace")
        .then((response) => response.text())
        .then((data) => dataSet(`active/${pageId}/ip`, data.split("ip=")[1].split("\n")[0]))
        .catch((e) => console.warn(e));
    dataOn(`active/${pageId}/url`, (url) => {
        if (url) {
            if (once && url !== window.location.href) {
                // listen for a change in url
                dataDelete(activeRef);
                window.location.href = url;
            }
            else {
                // ignore initial load
                once = true;
            }
        }
    });
}
